import { defineMutator } from "@rocicorp/zero"

import type { MutatorTx } from "../schema"
import type { PersonalSlackNotificationSettingsUpdate } from "../types"

export const personalSlackNotificationSettingsMutators = {
	update: defineMutator(
		async ({
			tx,
			args,
		}: {
			tx: MutatorTx
			args: PersonalSlackNotificationSettingsUpdate
		}) => {
			await tx.mutate.personalSlackNotificationSettings.update({
				...args,
				id: args.id,
				updatedAt: Date.now(),
			})
		},
	),
	delete: defineMutator(
		async ({ tx, args }: { tx: MutatorTx; args: { id: string } }) => {
			await tx.mutate.personalSlackNotificationSettings.delete({ id: args.id })
		},
	),
}
